import { COLOURS } from '../../../../../pp2/theme';
export var helperTextCss = "\n  color: ".concat(COLOURS.black, ";\n  margin-top: -0.25rem;\n  margin-bottom: 0.75rem;\n  line-height: 1.25rem;\n  font-size: 0.875rem;\n");